import React, { useEffect, useState, useCallback, useRef } from "react";
import { Grid } from "@mui/material";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import NotificationItemComponent from "./NotificationItemComponent";

function NotificationListComponent({
  notifications,
  handleMarkAsRead,
  handleDismiss,
  handleDismissAll,
  loadMoreNotifications
}) {
  const { t } = useTranslation();

  const [isInfiniteLoading, setIsInfiniteLoading] = useState(false);

  const iScroll = useRef();

  const handleInfiniteLoad = useCallback(async () => {
    setIsInfiniteLoading(true);

    await loadMoreNotifications();

    setIsInfiniteLoading(false);
  }, [loadMoreNotifications, setIsInfiniteLoading]);

  const onScroll = useCallback(async () => {
    const notifierBox = iScroll.current;
    const notifierBoxRectangle = notifierBox.getBoundingClientRect();
    const lastItemRectangle = notifierBox.lastElementChild.getBoundingClientRect();

    if (!isInfiniteLoading && lastItemRectangle.top < notifierBoxRectangle.bottom) {
      await handleInfiniteLoad();
    }
  }, [iScroll, handleInfiniteLoad, isInfiniteLoading]);

  useEffect(() => {
    iScroll.current.addEventListener("scroll", onScroll);
  }, [onScroll]);

  useEffect(() => {
    let iScrollCurrent = iScroll.current;
    return ()=>{
      iScrollCurrent.removeEventListener("scroll", onScroll);
  }}, [onScroll]);

  const ElementInfiniteLoad = () => {
    return <div>{t("Notifier.Loading")}</div>;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Button color="primary" size="small" onClick={handleDismissAll}>
          {t("Notifier.DismissAll")}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <div ref={iScroll} style={{ maxHeight: "200px", overflow: "auto" }}>
          {notifications.map(notification => {
            const text = notification.translatable
              ? t(notification.notificationTitle, {
                  data: notification.notificationBody || notification.sourceContextKeys
                })
              : notification.notificationTitle;
            return (
              <NotificationItemComponent
                key={notification.notificationId}
                notification={notification}
                text={text}
                onMarkAsRead={handleMarkAsRead}
                onDismiss={handleDismiss}
              />
            );
          })}
          {isInfiniteLoading && <ElementInfiniteLoad />}
        </div>
      </Grid>
    </Grid>
  );
}

NotificationListComponent.propTypes = {
  notifications: PropTypes.array.isRequired,
  handleMarkAsRead: PropTypes.func.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  handleDismissAll: PropTypes.func.isRequired,
  loadMoreNotifications: PropTypes.func.isRequired
};

export default NotificationListComponent;
